import { useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import type { ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';
import type { RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options_Options } from '@zg-rentals/ts-rental-manager-api-client-react-query';

export const usePropertyTableUnitOptions = (
  listingAlias: ListingAlias,
  options: Partial<RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options_Options> = {},
) => {
  const { data, error, isFetching } = useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options(
    { listingAlias },
    {
      ...options,
      enabled: Boolean(listingAlias) && (options.enabled ?? true),
      meta: {
        tags: ['propertyTableUnitOptions', listingAlias],
        context: {
          api: 'useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options',
          details: 'usePropertyTableUnitOptions',
        },
      },
    },
  );

  return {
    data,
    isFetching,
    error,
  };
};
